import React from 'react';

import { createRoot } from 'react-dom/client';

import Logger from '../../services/Logger';
import { CONSISTENCY_ACTIONS } from '../../helpers/shopify/consistencyActions';
import KeepMediaConsistentDialog from './KeepMediaConsistentDialog';

/**
 * Shows Master consistency dialog for direct listing attach.
 * @returns {Promise<{ action: string, dontShowAgain: boolean }>}
 */
export default function showKeepMediaConsistentDialog() {
  Logger.log('UI', 'ShowKeepMediaConsistentDialog');

  return new Promise((resolve) => {
    const dialogRoot = document.getElementById('dialogRoot');
    const wrapperDialog = document.createElement('div');
    wrapperDialog.id = 'wrapperKeepMediaConsistentDialog';
    wrapperDialog.className = 'wrapperDialogOverlay';
    dialogRoot.appendChild(wrapperDialog);

    const root = createRoot(wrapperDialog);

    const cleanup = (action, dontShowAgain = false) => {
      Logger.log('User', 'KeepMediaConsistentDialogClosed', {
        action,
        dontShowAgain,
      });
      try {
        root.unmount();
      } catch { /* ignore */ }
      if (wrapperDialog.parentNode) {
        dialogRoot.removeChild(wrapperDialog);
      }
      resolve({ action, dontShowAgain });
    };

    root.render(
      <KeepMediaConsistentDialog
        onAddToListingAndMaster={({ dontShowAgain }) => (
          cleanup(CONSISTENCY_ACTIONS.LISTING_AND_MASTER, dontShowAgain)
        )}
        onAddToListingOnly={({ dontShowAgain }) => (
          cleanup(CONSISTENCY_ACTIONS.LISTING_ONLY, dontShowAgain)
        )}
        onCancel={() => cleanup(CONSISTENCY_ACTIONS.CANCEL, false)}
      />,
    );
  });
}
